import React, { memo } from 'react';
import { Skeleton } from '@wwe-portal/ui/components/skeleton';
import './offer-card-banner.css';
import { useTranslations } from 'next-intl';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';
import { cn } from '@wwe-portal/ui/lib/lib';

const isLoading = false;

function OfferCardBanner() {
  const t = useTranslations();
  const { isMobile } = useResponsive();

  return (
    <div className="web-coin-shop overflow-hidden rounded-xl">
      <div
        className={cn(
          'banners web-coin-shop-banner relative flex overflow-hidden',
          {
            'bg-[url("/assets/images/web-coin/web-coin-shop-banner-mobile.webp")] bg-cover bg-center bg-repeat':
              isMobile,
          }
        )}
      >
        {!isMobile ? (
          <div className="web-coin-shop-content-background absolute">
            <img
              src="/assets/images/web-coin/webcoin-shop-effect.png"
              alt="eventBanner"
            />
          </div>
        ) : null}
        <div className="content web-coin-shop-content relative">
          {isLoading ? (
            <Skeleton className="w-full max-w-[150px] bg-[#6a73b5] text-xs" />
          ) : (
            <p className="font-weight-normal web-coin-shop-content-title text-blue700 m-0 p-0 text-xs uppercase">
              {t('web_coin_offers')}
            </p>
          )}
          {isLoading ? (
            <Skeleton className="mt-[5px] h-[30px] max-w-[350px] bg-[#6a73b5]" />
          ) : (
            <h3
              className={`mb-0 inline-block w-full text-2xl font-semibold ${
                isMobile ? 'text-text300 mt-0 text-sm' : 'text-text300 mt-[5px]'
              }`}
            >
              New Web Coin Offers are Available!
            </h3>
          )}
          {isLoading ? (
            <Skeleton className="mt-[10px] max-w-[200px] bg-[#6a73b5] text-sm" />
          ) : (
            <p
              className={`web-coin-shop-content-description mt-[10px] ${
                isMobile ? 'text-2xs mb-0' : 'text-text400 text-sm'
              }`}
            >
              {t('welcome_to_web_coin_shop')}
            </p>
          )}
        </div>
        {!isMobile && (
          <div className="banner-image web-coin-shop-image bg-[url('/assets/images/web-coin/webcoin-shop-banner-back.webp')] bg-cover bg-left-top bg-no-repeat" />
        )}
      </div>
    </div>
  );
}

export default memo(OfferCardBanner);
